import { useCallback, useEffect } from "react";
import { useSnackbar } from "JS/Helpers/Snackbar";
import {
    getIsRedirectedToBundleOptInPage,
    setIsRedirectedToBundleOptInPage,
} from "JS/Helpers/LocalStorageHelpers";
import { messaging } from "JS/Helpers/UserMessaging";
import {
    setBundleOptInLoadingState,
    setBundleOptInPopupState,
    setShowBundleOptInPopup,
    setSsoRedirectionPlace,
} from "JS/Redux/BundleOptIn";
import { useAppDispatch } from "JS/Redux/Store";
import { BundleOptInService } from "JS/Services/BundleOptIn/BundleOptInService";

export const useBundleOptIn = (skip: boolean = false) => {
    const dispatch = useAppDispatch();
    const service = new BundleOptInService();
    const { enqueueSnackbar } = useSnackbar();

    const getBundleOptInStatus = useCallback(() => {
        if (getIsRedirectedToBundleOptInPage() === "true") {
            setIsRedirectedToBundleOptInPage("false");

            dispatch(
                setBundleOptInPopupState({
                    showBundleOptInPopup: false,
                    loadingBundleOptIn: false,
                }),
            );
            return;
        }

        dispatch(
            setBundleOptInLoadingState({
                loadingBundleOptIn: true,
            }),
        );
        return service
            .getBundleOptInStatus()
            .then((response) => {
                if (!response?.status) {
                    enqueueSnackbar(
                        (response as any)?.message || messaging.common.error,
                        {
                            variant: "error",
                        },
                    );
                }

                const resData = response?.data;

                dispatch(
                    setShowBundleOptInPopup({
                        showBundleOptInPopup: !!resData?.showOptInPopup,
                    }),
                );
                dispatch(
                    setSsoRedirectionPlace({
                        ssoRedirectionPlace: resData?.redirectionPlace,
                    }),
                );

                return resData;
            })
            .catch((err) => {
                enqueueSnackbar(messaging.common.error, {
                    variant: "error",
                });
                throw err;
            })
            .finally(() =>
                dispatch(
                    setBundleOptInLoadingState({ loadingBundleOptIn: false }),
                ),
            );
    }, []);

    useEffect(() => {
        if (!skip) getBundleOptInStatus();
    }, [skip]);

    return {
        getBundleOptInStatus,
    };
};
